var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListdel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 20.5L16.3335 18",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6665 20.5L19.6665 18",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.834H25.5V13.834C25.0353 13.834 24.803 13.834 24.6098 13.8724C23.8164 14.0302 23.1962 14.6504 23.0384 15.4438C23 15.637 23 15.8693 23 16.334V20.6673C23 22.5529 23 23.4957 22.4142 24.0815C21.8284 24.6673 20.8856 24.6673 19 24.6673H17C15.1144 24.6673 14.1716 24.6673 13.5858 24.0815C13 23.4957 13 22.5529 13 20.6673V16.334C13 15.8693 13 15.637 12.9616 15.4438C12.8038 14.6504 12.1836 14.0302 11.3902 13.8724C11.197 13.834 10.9647 13.834 10.5 13.834V13.834Z",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.39 10.8088C16.4849 10.7202 16.6942 10.6419 16.9852 10.5861C17.2763 10.5303 17.6329 10.5 17.9998 10.5C18.3667 10.5 18.7234 10.5303 19.0144 10.5861C19.3055 10.6419 19.5148 10.7202 19.6097 10.8088",
    stroke: "#6D7D8B",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#6D7D8B",
    strokeOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListdel);
export default __webpack_public_path__ + "static/media/listdel.c3c9fb2c.svg";
export { ForwardRef as ReactComponent };